import React from 'react';

import { useClaim } from '~/components/ClaimContainer';
import { ContactEntity } from '~/components/Contact';
import Text from '~/components/core/TextComponents/Text';
import type { ContactFullModel } from '~/server_shared/swagger/data-contracts';

interface ContactRepresentativeLinkPropsType {
  contact: ContactFullModel;
}

const RepresentativeLink: React.FC<ContactRepresentativeLinkPropsType> = ({ contact }) => {
  const { claim } = useClaim();

  const involvedPersons = claim?.incident?.involved_persons ?? [];

  return (
    <>
      {involvedPersons
        .filter(
          (involved_person) =>
            involved_person?.contact_id === contact.id &&
            (involved_person?.representative_contact_id || involved_person?.attorney_contact_id)
        )
        .map((involved_person) => (
          <div className="inline-flex" key={involved_person?.id}>
            <Text variant={Text.VARIANTS.SM} colorVariant={Text.COLOR_VARIANTS.ERROR} weight={Text.WEIGHTS.REGULAR}>
              Represented
            </Text>
            <span className="ml-4">
              {involved_person?.representative_contact_id && (
                <ContactEntity contactId={involved_person.representative_contact_id} hideDisplayName />
              )}
              {involved_person?.attorney_contact_id && (
                <ContactEntity contactId={involved_person.attorney_contact_id} hideDisplayName />
              )}
            </span>
          </div>
        ))}
    </>
  );
};

export default RepresentativeLink;
